import React from 'react';
import {IUserInformationContext} from "../models/interfaces";

export const UserInformationContext = React.createContext<IUserInformationContext>
({userInfo: null, updateUserInfo: () => null, currentLanguage: null, handleLanguageChange: null});
